import {
  DataListSchoolYear,
  DataListTagGroup,
} from "src/app/shared/models/data-list";
import { KeyValuePair } from "src/app/shared/models/key-value-pair";
import { Lookup } from "src/app/shared/models/lookup";
import { AdministrativeUnit } from "src/app/shared/models/organizations/administrative-unit";

export class DialogData {
  documentationTypes: KeyValuePair[];
  title: string;
  fileName: string;
  allowedFileTypes: string;
  maxFileSize: number;
  maxFileSizeLabel: string;
  availableTags: DataListTagGroup[] = [];
  preselectedTagIds: string[] = [];
  isStateUser: boolean = false;
  availableAdministrativeUnits: AdministrativeUnit[] = [];
  documentTypes: Lookup[] = [];
  schoolYears: DataListSchoolYear[] = [];
  preselectedSchoolYear: string = "";
  preselectedDocumentType: string = "2";
  preselectedAdministrativeUnit: string = "";
  preselectedFiles: File[];
  preselectedAdministrativeUnitIndicatorId: string = "";
  preselectedAdministrativeUnitSurveyId: string = "";
  preselectedStudentId: string = "";
  preselectedIndicatorType: number = -1;
  isSchoolYearVisible: boolean = true;
  isAdministrativeUnitVisible: boolean = true;
  isReleaseDateVisible: boolean = true;
  isPublicVisible: boolean = true;
}
